/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
// eslint-disable-next-line max-classes-per-file
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import clsx from 'clsx';
import 'moment/locale/et';
import 'moment/locale/fi';
import 'moment/locale/ru';
import 'moment/locale/sv';
import * as R from 'ramda';
import React, { Component } from 'react';

import { withStyles } from '@mui/styles';
import { withTranslation } from 'react-i18next';

import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';

import InputAdornment from '@mui/material/InputAdornment';

import IntlTelInput from 'react-intl-tel-input';
import 'react-intl-tel-input/dist/main.css';

import { isEqual } from 'lodash';
import RenderRadioGroupWrapper from '../components/subcomponents/RadioGroup';
import { typography } from '../components/themes/instrumentarium/brandStyles';
import { siteIds } from '../constants';
import { siteId } from '../sites';

/**
 * Overwrite initial input field border style with gray color
 */
const inlineStyles = theme => ({
  phoneInput: {
    borderRadius: '4px',
    borderStyle: 'solid',
    borderWidth: '1px',
    height: 'auto',
  },
  phoneInputContainer: {
    marginBottom: theme.spacing(1),
    width: '100%',
    '&.MuiOutlinedIntlTelInput-root': {
      '&.allow-dropdown.separate-dial-code > .flag-container': {
        '& > .selected-flag': {
          display: 'flex',
          '& > .selected-dial-code': {
            paddingLeft: '5px',
            paddingTop: typography.padding.top,
          },
        },
        '& > .country-list': {
          width: '100%',
        },
      },
      '& > .MuiOutlinedIntlTelInput-input': {
        borderColor: 'rgba(0,0,0,0.23)',
        fontSize: 15,
        fontFamily: theme.typography.fontFamily,
        paddingTop: '21px',
        paddingBottom: '17px',
        width: '100%',

        '&:focus': {
          boxShadow: 'inset gray 0px 0px 2px 0px',
        },
      },
    },
  },
});

const renderTextFieldWrapped = ({
  autoComplete,
  input,
  label,
  helperText,
  id,
  disabled,
  type,
  val,
  placeholder,
  required,
  fullWidth,
  meta: { touched, error },
  adornment,
  t,
  classes,
  noBottomMargin,
}) => {
  return (
    <span>
      <InputLabel htmlFor={id} shrink style={{ textAlign: 'left', fontSize: '20px', color: '#000' }}>
        {label} {required && '*'}
      </InputLabel>
      <TextField
        id={id}
        style={{ marginTop: 0 }}
        InputProps={{
          style: { color: disabled ? 'inherit' : 'inherit' },
          classes: {
            notchedOutline: classes.notchedOutline,
            focused: classes.focused,
          },
          endAdornment: adornment && <InputAdornment position="end">{adornment}</InputAdornment>,
        }}
        disabled={disabled}
        onKeyPress={e => {
          // Allow only numeric characters and a comma
          const regexp = /[0-9,]+/;
          if (type === 'number' && !regexp.test(e.key)) {
            e.preventDefault();
          }
        }}
        helperText={helperText}
        fullWidth={fullWidth}
        required={required}
        margin="normal"
        type="text"
        {...input}
        value={val || input.value}
        variant="outlined"
        placeholder={placeholder}
        autoComplete={autoComplete}
      />
      {touched && error && (
        <Typography variant="body1" style={{ fontSize: 16, color: '#FE2213', textAlign: 'left' }}>
          {t(`validation.${error}`)}
        </Typography>
      )}
      <div style={{ marginBottom: `${noBottomMargin ? '0px ' : '24px'}` }} />
    </span>
  );
};

const renderTextField = withStyles(inlineStyles)(withTranslation('translations')(renderTextFieldWrapped));

class RenderPhoneNumberFieldWrapped extends Component {
  // eslint-disable-line
  constructor(props) {
    super(props);

    // Set initial state
    this.state = {
      number: props.val,
      fullNumber: '',
    };
  }

  setNumber = (number, countryCode) => {
    this.setState({
      number,
      fullNumber: `+${countryCode}${number}`,
    });
  };

  handlePhoneNumberChange = (_isValid, value, selectedCountryData) => {
    // If the field contains whitespaces, they are automatically removed.
    let cleanedPhoneNumber = value.trim().replace(' ', '');

    // If the field contains +358, it will be automatically removed.
    if (cleanedPhoneNumber.includes('+358')) {
      cleanedPhoneNumber = cleanedPhoneNumber.substring(4);
    }

    // If the field contains exactly 10 digits first of which is zero, the leading zero will be automatically removed.
    if (cleanedPhoneNumber.length === 10 && cleanedPhoneNumber.charAt(0) === '0') {
      cleanedPhoneNumber = cleanedPhoneNumber.substring(1);
    }

    this.setNumber(cleanedPhoneNumber, selectedCountryData.dialCode);
  };

  render() {
    const {
      input,
      label,
      disabled,
      id,
      fieldName,
      placeholder,
      required,
      meta: { touched, error },
      t,
      classes,
      noBottomMargin,
    } = this.props;

    const containerClassName = clsx(
      'intl-tel-input',
      'MuiOutlinedIntlTelInput-root', // Custom style
      'MuiInputBase-root',
      'MuiOutlinedInput-root',
      'MuiInputBase-fullWidth',
      'MuiInputBase-formControl',
      classes.phoneInputContainer,
    );

    const inputClassName = clsx(
      'form-control',
      'MuiOutlinedInput-input',
      'MuiOutlinedIntlTelInput-input', // Custom style
      classes.phoneInput,
      'MuiInputBase-input',
      'MuiOutlinedInput-notchedOutline',
    );
    const isEE = isEqual(siteId, siteIds.InstrumentariumEE);

    return (
      <span>
        <InputLabel htmlFor={id} shrink style={{ textAlign: 'left', fontSize: '20px', color: '#000' }}>
          {label} {required && '*'}
        </InputLabel>
        <IntlTelInput
          preferredCountries={['fi', 'se', 'ee']}
          placeholder={placeholder}
          fieldName={`${fieldName}-subscriberNumber`}
          fieldId={`${id}-subscriberNumber`}
          autoComplete="tel"
          containerClassName={containerClassName}
          inputClassName={inputClassName}
          separateDialCode
          defaultCountry={isEE ? 'ee' : 'fi'}
          onPhoneNumberBlur={this.handlePhoneNumberChange}
          onPhoneNumberChange={this.handlePhoneNumberChange}
          value={this.state.number}
          required={required}
          disabled={disabled}
          telInputProps={{
            style: { color: disabled ? 'inherit' : 'inherit' },
            classes: {
              notchedOutline: classes.notchedOutline,
              focused: classes.focused,
            },
          }}
        />
        <input
          type="hidden"
          name={fieldName}
          id={id}
          {...input}
          value={this.state.fullNumber}
          required={required}
          onChange={this.state.fullNumber ? input.onBlur(this.state.fullNumber) : () => {}}
        />

        {touched && error && (
          <Typography variant="body1" style={{ fontSize: 16, color: '#FE2213', textAlign: 'left' }}>
            {t(`validation.${error}`)}
          </Typography>
        )}
        <div style={{ marginBottom: `${noBottomMargin ? '0px ' : '24px'}` }} />
      </span>
    );
  }
}

const renderPhoneNumberField = withStyles(inlineStyles)(withTranslation('translations')(RenderPhoneNumberFieldWrapped));

const renderCheckbox = ({ input, label, disabled, val, meta: { error }, noMargin }) => (
  <div>
    <FormControlLabel
      control={<Checkbox checked={val} disabled={disabled} {...input} />}
      label={label}
      style={!noMargin ? { marginTop: 0, marginBottom: 24 } : {}}
    />
    {error && <span>{error}</span>}
  </div>
);

const renderRadioGroup = withStyles(inlineStyles)(withTranslation('translations')(RenderRadioGroupWrapper));

const renderTextArea = ({
  input,
  label,
  helperText,
  disabled,
  required,
  rows,
  fullWidth,
  meta: { touched, error },
}) => (
  <span>
    <InputLabel shrink style={{ textAlign: 'left', fontSize: '20px', color: '#000' }}>
      {label}
    </InputLabel>
    <TextField
      style={{ marginTop: 10, marginBottom: 24 }}
      error={touched && error}
      disabled={disabled}
      InputProps={{ style: { color: disabled ? 'inherit' : 'inherit' } }}
      helperText={helperText}
      multiline
      rows={rows || '4'}
      required={required}
      margin="normal"
      fullWidth={fullWidth}
      variant="outlined"
      {...input}
    />
  </span>
);

const inlineSelectStyles = () => ({});

class renderSelectFieldWrapped extends Component {
  // eslint-disable-line
  // eslint-disable-next-line react/state-in-constructor
  state = {
    selected: '',
  };

  handleSelectChange = event => {
    const { value } = event.target;
    this.setState({ selected: value });
  };

  render() {
    const {
      input,
      id,
      label,
      disabled,
      required,
      fullWidth,
      selOpts,
      optionsAreObjects,
      multiple,
      placeholder,
      onOpen,
      meta: { touched, error },
      t,
      translateOptions,
      classes,
      dataFetchInProgress,
    } = this.props;
    const { selected } = this.state;

    return (
      <div>
        <InputLabel htmlFor={id} shrink style={{ textAlign: 'left', fontSize: '20px' }}>
          {label} {required && '*'}
        </InputLabel>
        <FormControl fullWidth={fullWidth} style={{ marginBottom: '25px' }}>
          <Select
            className={classes.select}
            classes={{
              input: classes.input,
            }}
            style={{ textAlign: 'left' }}
            variant="outlined"
            value={multiple ? [...selected] : selected}
            disabled={disabled}
            onChange={event => this.handleSelectChange(event)}
            onOpen={
              onOpen &&
              (() => {
                onOpen();
              })
            }
            error={touched && error}
            displayEmpty
            fullWidth
            required={required}
            {...input}
            inputProps={{
              id,
              style: {
                padding: 0,
              },
            }}>
            <MenuItem value="">{placeholder || t('views.selectService.select')}</MenuItem>
            {dataFetchInProgress && (
              <div style={{ paddingTop: '12px', textAlign: 'center' }}>
                <CircularProgress className={classes.circularProgress} />
              </div>
            )}
            {R.prop('length', selOpts) > 0 &&
              selOpts.map(item =>
                optionsAreObjects ? (
                  <MenuItem key={item.key} value={JSON.stringify(item)}>
                    {translateOptions ? t(`options.${item.value}`) : item.value}
                  </MenuItem>
                ) : (
                  <MenuItem key={item} value={item}>
                    {translateOptions ? t(`options.${item}`) : item}
                  </MenuItem>
                ),
              )}
          </Select>
        </FormControl>
      </div>
    );
  }
}

const renderSelectField = withStyles(inlineSelectStyles)(withTranslation('translations')(renderSelectFieldWrapped));

const ssncheck = value => {
  const ssnRegExp = /^(0[1-9]|[12]\d|3[01])(0[1-9]|1[0-2])(\d\d-|[01]\dA|2[0-4]A)\d{3}[\dABCDEFHJKLMNPRSTUVWXY]$/g;
  const gChecks = '0123456789ABCDEFHJKLMNPRSTUVWXY';
  const ssnCheck = ssnRegExp.exec(value);

  if (ssnCheck) {
    const tmp1 = gChecks.charAt(parseInt(value.substr(0, 6) + value.substr(7, 3), 10) % 31);
    return tmp1 === value.charAt(10);
  }

  return Array.isArray(ssnCheck) && ssnCheck.length > 0;
};

const validatePhoneNumber = phoneNumber => {
  const phoneRegEx = /^[+][0-9]{9,14}$/im;
  return phoneRegEx.test(phoneNumber);
};

const validateEmail = email => {
  const emailRegEx = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,4})+$/;
  return emailRegEx.test(email);
};

/**
 * Submit validation
 * @param {} values
 */
export const validate = values => {
  const errors = {};
  const required = ['firstName', 'lastName', 'phoneNumber', 'email', 'personalID', 'preferredChannelOfCommunication'];
  const ssnrequired = ['personalID'];
  const phonerequired = ['phoneNumber'];
  const emailrequired = ['email'];

  required.forEach(field => {
    if (!values[field]) {
      errors[field] = 'required';
    }
  });

  ssnrequired.forEach(field => {
    if (!ssncheck(values[field])) {
      errors[field] = 'ssnrequired';
    }
  });

  phonerequired.forEach(field => {
    if (!validatePhoneNumber(values[field])) {
      errors[field] = 'phonerequired';
    }
  });

  emailrequired.forEach(field => {
    if (!validateEmail(values[field])) {
      errors[field] = 'emailrequired';
    }
  });

  return errors;
};

export const returnField = fieldType => {
  switch (fieldType) {
    case 'number':
    case 'text':
    case 'date':
      return renderTextField;
    case 'phonenumber':
      return renderPhoneNumberField;
    case 'checkbox':
      return renderCheckbox;
    case 'radiogroup':
      return renderRadioGroup;
    case 'textarea':
      return renderTextArea;
    case 'select':
      return renderSelectField;
    default:
      return renderTextField;
  }
};
